import React from "react";
import { Link } from "react-router-dom";

export default function FathersDayPromo() {
  // Order Online goes live at 12:00am the night before the Saturday service.
  const now = new Date();
  const orderOpens = new Date(2026, 5, 20, 0, 0, 0); // 12am Sat, June 20, 2026
  const ordersOpen = now >= orderOpens;

  return (
    <div className="fathers-day-promo" aria-label="Father's Day Specials">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Playfair+Display:wght@500;600;700&family=Outfit:wght@400;600;700&display=swap');

        @keyframes fdpDrift1 {
          0%   { transform: translate(0, 0) rotate(-8deg); }
          50%  { transform: translate(86vw, 26px) rotate(8deg); }
          100% { transform: translate(0, 0) rotate(-8deg); }
        }
        @keyframes fdpDrift2 {
          0%   { transform: translate(0, 0) rotate(6deg); }
          50%  { transform: translate(-80vw, 32px) rotate(-6deg); }
          100% { transform: translate(0, 0) rotate(6deg); }
        }
        @keyframes fdpTwinkle {
          0%, 100% { opacity: 0.25; transform: scale(0.9); }
          50%      { opacity: 0.7;  transform: scale(1.1); }
        }

        .fathers-day-promo {
          --fdp-navy: #0e1b45;
          --fdp-blue: #1c357e;
          --fdp-royal: #2747a8;
          --fdp-gold: #d4b15f;
          --fdp-gold-light: #ecd489;
          --fdp-silver: #cdd6ef;
          --fdp-cream: #f7f4ea;

          position: relative;
          width: 100%;
          min-height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background:
            radial-gradient(ellipse at 50% 0%, rgba(39, 71, 168, 0.65) 0%, rgba(14, 27, 69, 0) 60%),
            linear-gradient(160deg, #0c1838 0%, #16275f 45%, #1c357e 100%);
          overflow: hidden;
          font-family: 'Outfit', sans-serif;
        }

        .fathers-day-promo__border {
          position: relative;
          z-index: 2;
          border: 2px solid var(--fdp-gold);
          outline: 1px solid rgba(212, 177, 95, 0.5);
          outline-offset: 6px;
          background: rgba(10, 22, 56, 0.72);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35), inset 0 0 60px rgba(39, 71, 168, 0.25);
          padding: 2.5rem 2.5rem 1.75rem;
          max-width: 600px;
          width: 86%;
          text-align: center;
        }

        .fathers-day-promo__icon {
          display: block;
          margin: 0 auto 0.25rem;
          font-size: 2.2rem;
          line-height: 1;
          filter: drop-shadow(0 2px 4px rgba(0,0,0,0.4));
        }

        .fathers-day-promo__title {
          font-family: 'Great Vibes', cursive;
          font-size: 3.6rem;
          color: var(--fdp-cream);
          margin: 0 0 0.2rem;
          line-height: 1;
          text-shadow: 0 2px 10px rgba(0,0,0,0.4);
        }

        .fathers-day-promo__eyebrow {
          font-family: 'Playfair Display', serif;
          font-size: 1.2rem;
          font-weight: 600;
          color: var(--fdp-gold-light);
          text-transform: uppercase;
          letter-spacing: 6px;
          margin: 0 0 0.85rem;
        }

        .fathers-day-promo__hours {
          font-size: 1.02rem;
          font-weight: 700;
          color: var(--fdp-silver);
          margin: 0 0 0.2rem;
          letter-spacing: 0.5px;
        }

        .fathers-day-promo__hours span {
          color: var(--fdp-gold-light);
        }

        .fathers-day-promo__divider {
          width: 64%;
          max-width: 320px;
          height: 1px;
          margin: 1.1rem auto;
          background: linear-gradient(90deg, transparent, var(--fdp-gold), transparent);
          position: relative;
        }
        .fathers-day-promo__divider::after {
          content: '◆';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--fdp-gold);
          font-size: 0.7rem;
          background: var(--fdp-navy);
          padding: 0 0.5rem;
        }

        .fathers-day-promo__items {
          list-style: none;
          padding: 0;
          margin: 0 0 0.9rem;
        }

        .fathers-day-promo__items li {
          font-family: 'Playfair Display', serif;
          font-size: 1.04rem;
          font-weight: 600;
          color: var(--fdp-cream);
          padding: 0.28rem 0;
          letter-spacing: 0.4px;
        }

        .fathers-day-promo__items li .price {
          color: var(--fdp-gold-light);
          font-weight: 700;
        }

        .fathers-day-promo__drinks {
          font-size: 0.92rem;
          color: var(--fdp-silver);
          opacity: 0.9;
          font-style: italic;
          margin: 0 0 1.4rem;
          letter-spacing: 0.3px;
        }

        .fathers-day-promo__cta-group {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
        }

        .fathers-day-promo__cta,
        .fathers-day-promo__cta:visited,
        .fathers-day-promo__cta:active {
          display: inline-block;
          background: linear-gradient(180deg, var(--fdp-gold-light), var(--fdp-gold));
          color: var(--fdp-navy) !important;
          padding: 0.85rem 2.2rem;
          border-radius: 6px;
          font-weight: 700;
          font-size: 1rem;
          text-transform: uppercase;
          letter-spacing: 2px;
          text-decoration: none;
          border: 1px solid var(--fdp-gold-light);
          box-shadow: 0 4px 14px rgba(0,0,0,0.3);
          transition: transform 150ms ease, box-shadow 200ms ease;
        }

        .fathers-day-promo__cta:hover {
          color: var(--fdp-navy) !important;
          transform: scale(1.04);
          box-shadow: 0 6px 20px rgba(0,0,0,0.4);
        }

        .fathers-day-promo__opens-note {
          font-size: 0.95rem;
          font-weight: 600;
          color: var(--fdp-silver);
          background: rgba(39, 71, 168, 0.35);
          border: 1px dashed rgba(212, 177, 95, 0.6);
          border-radius: 6px;
          padding: 0.7rem 1.2rem;
          margin: 0;
          letter-spacing: 0.5px;
        }
        .fathers-day-promo__opens-note strong {
          color: var(--fdp-gold-light);
        }

        .fathers-day-promo__menu-link,
        .fathers-day-promo__menu-link:visited,
        .fathers-day-promo__menu-link:active {
          display: inline-block;
          color: var(--fdp-gold-light) !important;
          font-weight: 600;
          font-size: 0.95rem;
          text-decoration: underline;
          text-underline-offset: 3px;
          transition: color 200ms ease;
        }

        .fathers-day-promo__menu-link:hover {
          color: var(--fdp-cream) !important;
        }

        /* Corner flourishes */
        .fathers-day-promo__corner {
          position: absolute;
          font-size: 2rem;
          color: var(--fdp-gold);
          opacity: 0.5;
          z-index: 2;
          pointer-events: none;
        }
        .fathers-day-promo__corner--tl { top: 18px; left: 22px; }
        .fathers-day-promo__corner--tr { top: 18px; right: 22px; }
        .fathers-day-promo__corner--bl { bottom: 18px; left: 22px; }
        .fathers-day-promo__corner--br { bottom: 18px; right: 22px; }

        /* Drifting decorations */
        .fathers-day-promo__decor {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 1;
          overflow: hidden;
        }
        .fathers-day-promo__tie {
          position: absolute;
          font-size: 1.7rem;
          filter: drop-shadow(0 2px 3px rgba(0,0,0,0.3));
        }
        .fathers-day-promo__tie--1 {
          top: 14%;
          left: -4%;
          opacity: 0.45;
          animation: fdpDrift1 22s ease-in-out infinite;
        }
        .fathers-day-promo__tie--2 {
          bottom: 16%;
          right: -4%;
          font-size: 1.4rem;
          opacity: 0.35;
          animation: fdpDrift2 26s ease-in-out infinite 4s;
        }
        .fathers-day-promo__star {
          position: absolute;
          color: var(--fdp-gold-light);
          font-size: 0.9rem;
          animation: fdpTwinkle 4s ease-in-out infinite;
        }
        .fathers-day-promo__star--1 { top: 20%; left: 14%; animation-delay: 0s; }
        .fathers-day-promo__star--2 { top: 30%; right: 12%; animation-delay: 1.2s; font-size: 1.1rem; }
        .fathers-day-promo__star--3 { bottom: 24%; left: 20%; animation-delay: 2.1s; }
        .fathers-day-promo__star--4 { bottom: 30%; right: 18%; animation-delay: 0.6s; font-size: 1.05rem; }
        .fathers-day-promo__star--5 { top: 50%; left: 8%; animation-delay: 1.8s; }

        @media (max-width: 600px) {
          .fathers-day-promo {
            min-height: 440px;
          }
          .fathers-day-promo__border {
            padding: 1.6rem 1.25rem 1.25rem;
            width: 90%;
          }
          .fathers-day-promo__title {
            font-size: 2.5rem;
          }
          .fathers-day-promo__eyebrow {
            font-size: 0.9rem;
            letter-spacing: 3px;
          }
          .fathers-day-promo__hours {
            font-size: 0.9rem;
          }
          .fathers-day-promo__items li {
            font-size: 0.92rem;
          }
          .fathers-day-promo__drinks {
            font-size: 0.82rem;
          }
          .fathers-day-promo__cta {
            padding: 0.7rem 1.6rem;
            font-size: 0.88rem;
          }
          .fathers-day-promo__corner { font-size: 1.5rem; }
        }
      `}</style>

      <div className="fathers-day-promo__decor" aria-hidden="true">
        <span className="fathers-day-promo__tie fathers-day-promo__tie--1">👔</span>
        <span className="fathers-day-promo__tie fathers-day-promo__tie--2">👔</span>
        <span className="fathers-day-promo__star fathers-day-promo__star--1">✦</span>
        <span className="fathers-day-promo__star fathers-day-promo__star--2">✦</span>
        <span className="fathers-day-promo__star fathers-day-promo__star--3">✦</span>
        <span className="fathers-day-promo__star fathers-day-promo__star--4">✦</span>
        <span className="fathers-day-promo__star fathers-day-promo__star--5">✦</span>
      </div>

      <span className="fathers-day-promo__corner fathers-day-promo__corner--tl" aria-hidden="true">❧</span>
      <span className="fathers-day-promo__corner fathers-day-promo__corner--tr" aria-hidden="true">❧</span>
      <span className="fathers-day-promo__corner fathers-day-promo__corner--bl" aria-hidden="true">❧</span>
      <span className="fathers-day-promo__corner fathers-day-promo__corner--br" aria-hidden="true">❧</span>

      <div className="fathers-day-promo__border">
        <span className="fathers-day-promo__icon" aria-hidden="true">🥃</span>
        <h2 className="fathers-day-promo__title">Father's Day</h2>
        <p className="fathers-day-promo__eyebrow">Specials</p>

        <p className="fathers-day-promo__hours">
          <span>Saturday</span> 7am–10pm &nbsp;·&nbsp; <span>Sunday</span> 7am–8pm
        </p>

        <div className="fathers-day-promo__divider"></div>

        <ul className="fathers-day-promo__items">
          <li>Chimichurri New York Steak <span className="price">$29.99</span></li>
          <li>Papa's Carne Asada Chilaquiles <span className="price">$24.95</span></li>
          <li>Strawberry Pancake Stack <span className="price">$18.95</span></li>
          <li>Famous Homemade Bread Pudding <span className="price">$8.99</span></li>
        </ul>

        <p className="fathers-day-promo__drinks">
          Maple Old Fashioned $14 &nbsp;·&nbsp; Strawberry Mimosas $7 / carafe $16.49
        </p>

        <div className="fathers-day-promo__cta-group">
          {ordersOpen ? (
            <Link to="/burbank/order" className="fathers-day-promo__cta">
              Order Online
            </Link>
          ) : (
            <p className="fathers-day-promo__opens-note">
              Online ordering opens <strong>12am Sat, June 20</strong>
            </p>
          )}
          <a
            href="/lancers-fathers-day-2026.jpeg"
            target="_blank"
            rel="noopener noreferrer"
            className="fathers-day-promo__menu-link"
          >
            View Father's Day Menu
          </a>
        </div>
      </div>
    </div>
  );
}
